const ContactSectionType = {
    technicalContactOne: 1,
    technicalContactTwo: 2,
    businessContactOne: 3,
    businessContactTwo: 4,
    operationContactOne: 5,
    operationContactTwo: 6,
    certificateContactOne: 7,
    certificateContactTwo: 8,
    certificateTestContactOne: 9,
    certificateTestContactTwo: 10
}

export default ContactSectionType;